import { ClientCreationForm } from 'components/Pages/Clients';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const ClientCreationPage: React.FC = () => {
  const navigate = useNavigate();

  const onCreate = useCallback((): void => {
    navigate('/configuracoes/clientes');
  }, [navigate]);

  return (
    <Scaffold>
      <ClientCreationForm onCreate={onCreate} />
    </Scaffold>
  );
};
